import loadDateTimePicker from "common/datetimepicker/loadDateTimePicker";
import { defaultTo, not, pipe } from "ramda";

angular.module("ticketco/common").directive("tcDateTime", tcDateTime);

// DateTime directive body
/* @ngInject */
function tcDateTime() {
  return {
    scope: {
      ngModel: "=",
      tcDateTime: "<",
    },
    require: "ngModel",
    link: function (scope, elem, attrs, ngModelCtrl) {
      var validateTime = function (x) {
        return (x || "").trim() === "" ? null : x;
      };

      // We should use space as separator between date and time
      // This function replace space with "T" to make string parsable
      var normalizeTime = function (x) {
        var y = x.replace(" ", "T");
        return y;
      };

      var defaultSettings = {
        value: scope.ngModel || "",
        dayOfWeekStart: 1,
        format: "Y-m-d H:i",
        formatTime: "H:i",
        formatDate: "Y-m-d",
        mask: true,
        lang: "no",
        step: 1,
        i18n: {
          no: {
            // Norwegian
            months: [
              "Januar",
              "Februar",
              "Mars",
              "April",
              "Mai",
              "Juni",
              "Juli",
              "August",
              "September",
              "Oktober",
              "November",
              "Desember",
            ],
            dayOfWeek: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"],
          },
        },
      };

      var elementSettings = scope.tcDateTime;

      var settings = {
        ...defaultSettings,
        onChangeDateTime: function (ct, $el) {
          ngModelCtrl.$setViewValue($el[0].value);
        },
        startDate: scope.ngModel ? undefined : Date.now(),
        ...elementSettings,
      };

      ngModelCtrl.$validators.datetime = pipe(
        validateTime,
        defaultTo("2002-02-02"),
        normalizeTime,
        Date.parse,
        isNaN,
        not
      );

      ngModelCtrl.$render = function (value) {
        loadDateTimePicker().then(() => {
          $(elem).datetimepicker("destroy");
          $(elem).datetimepicker(settings);
        });
      };

      elem.on("$destroy", function () {
        $(elem).datetimepicker("destroy");
      });
    },
  };
}

// MinDateTime directive
dateTimeValidatorFactory({
  name: "tcMinDateTime",
  key: "minDateTime",
  validatorFn: function (x, y) {
    return x <= y;
  },
});

// MaxDateTime directive
dateTimeValidatorFactory({
  name: "tcMaxDateTime",
  key: "maxDateTime",
  validatorFn: function (x, y) {
    return x >= y;
  },
});

function dateTimeValidatorFactory(options) {
  angular.module("ticketco/common").directive(options.name, [
    "$parse",
    function validator($parse) {
      return {
        require: "ngModel",
        link: function (scope, elem, attrs, ngModelCtrl) {
          ngModelCtrl.$validators[options.key] = function (
            modelValue,
            viewValue
          ) {
            var fieldDate = modelValue || viewValue;
            var compareDate = $parse(attrs[options.name])(scope);
            return options.validatorFn(compareDate, fieldDate);
          };

          scope.$watch(
            function () {
              return $parse(attrs[options.name])(scope);
            },
            function () {
              ngModelCtrl.$validate();
            }
          );
        },
      };
    },
  ]);
}
